import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import React from "react";
import { ViewOrdersCTA } from "./ctas";
import { EditOrderInformationIA } from "./instantAnswersComponents/orders/EditOrderInformationIA";
export var editOrderInformation = function editOrderInformation(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return EDIT_ORDER_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return EDIT_ORDER_DESCRIPTION(context);
    }
  };
};
var EDIT_ORDER_TITLE = function EDIT_ORDER_TITLE(strictLocalize) {
  return strictLocalize({
    id: "AIrU/s",
    defaultMessage: [{
      "type": 0,
      "value": "Editar informações da encomenda"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return {
      label: strictLocalize({
        id: "lwjzVj",
        defaultMessage: [{
          "type": 0,
          "value": "Editar encomenda"
        }]
      }),
      getLink: function getLink() {
        return brandPortalOrdersbrandOrderTokenEdit(brandOrderToken);
      }
    };
  }
  return ViewOrdersCTA(strictLocalize);
};
var EDIT_ORDER_DESCRIPTION = function EDIT_ORDER_DESCRIPTION(context) {
  return /*#__PURE__*/React.createElement(EditOrderInformationIA, {
    context: context
  });
};